module.exports = __webpack_public_path__ + "img/icon_warning.2c64f65d.png";